import type { CurrencyId } from "./currencies";

export type ChainId = "BITCOIN" | "ETHEREUM" | "POLYGON" | "BSC" | "TRON";

export interface Chain {
	id: ChainId;
	label: string;
	iconName: string;
	nativeTicker: CurrencyId;
	color: string;
	aliases: string[];
}

export const chains: Record<ChainId, Chain> = {
	BITCOIN: {
		id: "BITCOIN",
		label: "Bitcoin",
		iconName: "btc",
		nativeTicker: "BTC",
		color: "#f7931a",
		aliases: ["BTC"],
	},
	ETHEREUM: {
		id: "ETHEREUM",
		label: "Ethereum",
		iconName: "eth",
		nativeTicker: "ETH",
		color: "#3b82f6",
		aliases: ["ETH"],
	},
	POLYGON: {
		id: "POLYGON",
		label: "Polygon",
		iconName: "matic",
		nativeTicker: "MATIC",
		color: "#8b5cf6",
		aliases: ["MATIC"],
	},
	BSC: {
		id: "BSC",
		label: "BNB Chain",
		iconName: "bnb",
		nativeTicker: "BNB",
		color: "#f59e0b",
		aliases: ["BNB", "BNB_CHAIN", "BINANCE"],
	},
	TRON: {
		id: "TRON",
		label: "TRON",
		iconName: "tron",
		nativeTicker: "TRX",
		color: "#dc2626",
		aliases: ["TRX"],
	},
};

export const chainList: Chain[] = Object.values(chains);

export const getChain = (id: string): Chain | undefined => {
	const key = id.toUpperCase();
	if (key in chains) return chains[key as ChainId];
	return chainList.find((c) => c.aliases.includes(key));
};
